import generateAdditionalData from './generateAdditionalDataActions';
import clearAdditionalDataErrors from './clearAdditionalDataErrorsActions';

export default {
  generateAdditionalData,
  clearAdditionalDataErrors,
};
